export default "./dist/stdassets/images/icons/legend-theme.png";